import { NgModule } from "@angular/core";
import { CluConfirmDialogComponent } from "./clu-confirm-dialog.component";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/material.module";
import { CluConfirmDialogService } from "./clu-confirm-dialog.service";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [CluConfirmDialogComponent],
    imports: [
        CommonModule,
        TranslateModule,
        MaterialModule, 
        FormsModule
    ],
    providers: [CluConfirmDialogService]
})
export class CluConfirmDialogModule {}